import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';

const BibliaOrtodoxaPrivacy = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="min-h-screen pt-20 bg-gray-50 dark:bg-[#0a0e17] transition-colors duration-300">
            {/* Header */}
            <div className="bg-white dark:bg-[#111621] border-b border-gray-100 dark:border-gray-800 py-12">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                    <Link to="/" className="inline-flex items-center text-primary-600 dark:text-primary-400 hover:text-primary-700 font-medium mb-6">
                        <ArrowLeft className="w-4 h-4 mr-2" /> Înapoi la pagina principală
                    </Link>
                    <div className="flex items-center space-x-3 mb-4">
                        <Shield className="w-8 h-8 text-primary-500" />
                        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">POLITICA DE CONFIDENȚIALITATE</h1>
                    </div>
                    <p className="text-gray-600 dark:text-gray-400">
                        Ultima actualizare: Decembrie 2025
                    </p>
                </div>
            </div>

            {/* Content */}
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="prose prose-lg dark:prose-invert max-w-none text-gray-600 dark:text-gray-300 space-y-8">

                    <section>
                        <h3>1. Introducere</h3>
                        <p>
                            Această Politică de Confidențialitate descrie modul în care IronGate Software LTD („Compania", „noi", „nouă") colectează, utilizează și protejează datele personale ale utilizatorilor aplicației BibliaOrtodoxa App („Aplicația").
                        </p>
                        <p>
                            Respectăm legislația europeană privind protecția datelor, în special Regulamentul (UE) 2016/679 (GDPR).
                        </p>
                    </section>

                    <section>
                        <h3>2. Operatorul de date</h3>
                        <p className="bg-white dark:bg-white/5 p-4 rounded-lg border border-gray-200 dark:border-gray-800">
                            <b>Denumire:</b> IronGate Software LTD<br />
                            <b>Sediu:</b> Republica Irlanda<br />
                            <b>Email contact:</b> contact@irongate.ie
                        </p>
                    </section>

                    <section>
                        <h3>3. Date colectate</h3>
                        <p><b>Nu colectăm niciun fel de date personale.</b></p>
                        <p>Aplicația poate solicita următoarele permisiuni, care sunt utilizate exclusiv local pe dispozitivul dvs.:</p>
                        
                        <h4>3.1. Permisiuni solicitate:</h4>
                        <ul>
                            <li><b>Acces la contacte:</b> pentru a afișa numele contactelor în funcția de onomastică. Datele nu sunt transmise către serverele noastre.</li>
                            <li><b>Acces la galeria foto:</b> pentru a salva imaginile de fundal (wallpapers) pe dispozitivul dvs. Datele nu sunt transmise către serverele noastre.</li>
                        </ul>

                        <h4>3.2. Utilizarea permisiunilor:</h4>
                        <p>Toate datele accesate prin aceste permisiuni rămân exclusiv pe dispozitivul dvs. și nu sunt colectate, stocate sau transmise către noi sau terți.</p>
                    </section>

                    <section>
                        <h3>4. Scopul prelucrării datelor</h3>
                        <p>Datele sunt prelucrate pentru următoarele scopuri:</p>
                        <ul>
                            <li>Funcționarea corectă a Aplicației</li>
                            <li>Personalizarea experienței utilizatorului</li>
                            <li>Îmbunătățirea performanței și funcționalităților</li>
                            <li>Remedierea erorilor și problemelor tehnice</li>
                            <li>Comunicări legate de actualizări importante (opțional)</li>
                        </ul>
                    </section>

                    <section>
                        <h3>5. Temeiul legal al prelucrării</h3>
                        <ul>
                            <li><b>Executarea contractului</b> – furnizarea serviciilor solicitate</li>
                            <li><b>Consimțământul utilizatorului</b> – pentru funcționalități opționale</li>
                            <li><b>Interesul legitim</b> – îmbunătățirea aplicației și securitate</li>
                        </ul>
                    </section>

                    <section>
                        <h3>6. Partajarea datelor</h3>
                        <p>Datele pot fi partajate cu:</p>
                        <ul>
                            <li><b>Furnizori de servicii:</b> platforme de analiză (ex: Firebase Analytics) - doar date anonimizate</li>
                            <li><b>Platforme de distribuție:</b> Apple App Store (conform politicilor lor)</li>
                            <li><b>Autorități:</b> doar în cazurile prevăzute de lege</li>
                        </ul>
                        <p>
                            <b>Nu vindem și nu transferăm datele personale către terți în scopuri comerciale.</b>
                        </p>
                    </section>

                    <section>
                        <h3>7. Stocarea datelor</h3>
                        <ul>
                            <li>Datele sunt stocate pe servere securizate</li>
                            <li>Durata stocării: pe perioada utilizării Aplicației + 30 zile după dezinstalare</li>
                            <li>Datele anonimizate pentru statistici pot fi păstrate pe termen nelimitat</li>
                        </ul>
                    </section>

                    <section>
                        <h3>8. Securitatea datelor</h3>
                        <p>Implementăm măsuri tehnice și organizatorice pentru protejarea datelor:</p>
                        <ul>
                            <li>Criptare în tranzit (HTTPS/TLS)</li>
                            <li>Acces restricționat la date</li>
                            <li>Monitorizare și audituri regulate</li>
                            <li>Pseudonimizare unde este posibil</li>
                        </ul>
                    </section>

                    <section>
                        <h3>9. Drepturile utilizatorilor</h3>
                        <p>Conform GDPR, aveți următoarele drepturi:</p>
                        <ul>
                            <li><b>Dreptul de acces</b> – să solicitați o copie a datelor dvs.</li>
                            <li><b>Dreptul de rectificare</b> – să corectați datele inexacte</li>
                            <li><b>Dreptul de ștergere</b> – să solicitați ștergerea datelor („dreptul de a fi uitat")</li>
                            <li><b>Dreptul de restricționare</b> – să limitați prelucrarea datelor</li>
                            <li><b>Dreptul la portabilitate</b> – să primiți datele într-un format structurat</li>
                            <li><b>Dreptul de opoziție</b> – să vă opuneți prelucrării în anumite situații</li>
                            <li><b>Dreptul de retragere a consimțământului</b> – în orice moment, fără a afecta legalitatea prelucrării anterioare</li>
                        </ul>
                    </section>

                    <section>
                        <h3>10. Exercitarea drepturilor</h3>
                        <p>Pentru a vă exercita drepturile, ne puteți contacta la:</p>
                        <p className="bg-white dark:bg-white/5 p-4 rounded-lg border border-gray-200 dark:border-gray-800">
                            <b>Email:</b> contact@irongate.ie<br />
                            <b>Termen de răspuns:</b> maximum 30 de zile
                        </p>
                    </section>

                    <section>
                        <h3>11. Transferuri internaționale</h3>
                        <p>
                            Datele pot fi prelucrate pe servere situate în Spațiul Economic European (SEE). În cazul transferurilor în afara SEE, aplicăm garanții adecvate (clauze contractuale standard sau decizii de adecvare).
                        </p>
                    </section>

                    <section>
                        <h3>12. Cookie-uri și tehnologii similare</h3>
                        <p>Aplicația poate utiliza tehnologii de stocare locală pentru:</p>
                        <ul>
                            <li>Salvarea preferințelor utilizatorului</li>
                            <li>Funcționarea offline</li>
                            <li>Îmbunătățirea performanței</li>
                        </ul>
                        <p>Nu utilizăm cookie-uri de publicitate sau tracking terți.</p>
                    </section>

                    <section>
                        <h3>13. Minori</h3>
                        <p>
                            Aplicația nu colectează în mod intenționat date de la copii sub 16 ani fără consimțământul parental. Dacă descoperiți că un minor a furnizat date fără autorizație, contactați-ne pentru ștergere.
                        </p>
                    </section>

                    <section>
                        <h3>14. Modificări ale Politicii</h3>
                        <p>
                            Această politică poate fi actualizată periodic. Modificările semnificative vor fi comunicate prin Aplicație. Data ultimei actualizări este afișată la începutul documentului.
                        </p>
                    </section>

                    <section>
                        <h3>15. Autoritatea de supraveghere</h3>
                        <p>Aveți dreptul de a depune o plângere la:</p>
                        <ul>
                            <li><b>În Irlanda:</b> Data Protection Commission (DPC) - <a href="https://www.dataprotection.ie" target="_blank" rel="noopener noreferrer" className="text-primary-500 hover:text-primary-600">www.dataprotection.ie</a></li>
                            <li><b>În România:</b> Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP) - <a href="https://www.dataprotection.ro" target="_blank" rel="noopener noreferrer" className="text-primary-500 hover:text-primary-600">www.dataprotection.ro</a></li>
                        </ul>
                    </section>

                    <section>
                        <h3>16. Contact</h3>
                        <p>Pentru orice întrebări privind această politică sau datele dvs.:</p>
                        <p className="bg-white dark:bg-white/5 p-4 rounded-lg border border-gray-200 dark:border-gray-800">
                            <b>Email:</b> contact@irongate.ie<br />
                            <b>Companie:</b> IronGate Software LTD, Republica Irlanda
                        </p>
                    </section>

                    <section className="text-center pt-8 border-t border-gray-200 dark:border-gray-800">
                        <p>
                            Prin utilizarea Aplicației, confirmați că ați citit și înțeles această Politică de Confidențialitate.
                        </p>
                        <p className="text-lg font-medium text-primary-600 dark:text-primary-400 mt-4">
                            Dumnezeu să vă binecuvânteze!
                        </p>
                    </section>

                </div>
            </div>
        </div>
    );
};

export default BibliaOrtodoxaPrivacy;
